import { CuraIcon, CuraParagraph } from '@rededor/cura-react'
import { Props } from '.'
import { Bold } from '../UnitCard/styles'
import * as S from './styles'
// import { Strong500, Strong700 } from '@/shared/styles/strongs'

export const Info = ({ style }: Props) => {
  return (
    <S.ContainerInfo style={style}>
      <CuraParagraph size="small" marginBlock="24px 0" color="neutral-dark">
        <Bold $weight="bold">Horário de funcionamento:</Bold>
      </CuraParagraph>
      <S.InfoTable>
        <S.Type>
          <S.IconWrapper>
            <CuraIcon name="central" color="primary" size={16} />
          </S.IconWrapper>
          <CuraParagraph size="xsmall" color="neutral-dark" marginBlock="0">
            <Bold $weight="bold">Central</Bold>
          </CuraParagraph>
        </S.Type>
        <CuraParagraph size="xsmall" color="neutral-dark" marginBlock="6px 0">
          <Bold $weight="bold">
            Segunda a sexta, 7h às 20h
            <br />
            Sábado, 7h às 15h
          </Bold>
        </CuraParagraph>
        <S.Type>
          <S.IconWrapper>
            <CuraIcon name="chatCircle" color="primary" size={16} />
          </S.IconWrapper>
          <CuraParagraph size="xsmall" color="neutral-dark" marginBlock="0">
            <Bold $weight="bold">Chat</Bold>
          </CuraParagraph>
        </S.Type>
        <CuraParagraph size="xsmall" color="neutral-dark" marginBlock="6px 0">
          <Bold $weight="bold">
            Segunda a sábado, 7h às 23h
            <br />
            Domingo, 7h às 15h
          </Bold>
        </CuraParagraph>
      </S.InfoTable>
    </S.ContainerInfo>
  )
}
